export const withdrawTransaction = {
  withdrawTransactions: "Withdraw transactions V1",
  clearHoldBalance : "Clear Hold Balance",
  from: "From",
  to: "To",
  advanceFilter: "Advance filter",
  userPhone: "User phone",
  approvedBy: "Approved By",
  status: "Status",
  selected: "Selected",
  submited: "SUBMITED",
  rejected: "REJECTED",
  pending: "PENDING",
  success: "SUCCESS",
  dateRequested: "Date Requested",
  dateApproved: "Date Approved",
  withdrawSuccess: "WITHDRAW_SUCCESS",
  payoutSubmited: "PAYOUT_SUBMITED",
  user: "User",
  amount: "Amount",
  autoApprove: "AUTO_APPROVED",
  confirmQuestion: "Do you want to reject this transaction?",
  yes: "Yes",
  no: "No",
  rtbId: "RTB ID",
  reject: "REJECT",
  approve: "APPROVE",
  refCode: "Reference",
  approveMessage: "Approve Message",
  paymentGatewayId: "Payment Gateway Id",
  channel: "Channel"
};
